import debounce from 'lodash.debounce';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.searchViolations ? vm.searchViolations[cause] : []
);

/**
 * @description Примесь добавления услуг из прайса.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Нарушения строки поиска.
     * @type {string[]}
     */
    searchInputViolations: resolveInputErrors('match'),
    /**
     * @description Показывать аккордеон услуг.
     * @type {boolean}
     */
    shownAccordionServices() {
      return !this.searchQuery;
    },
    /**
     * @description Поиск по дефолтному прайс-листу.
     * @type {Boolean}
     */
    byDefaultServicePriceList() {
      return !this.selectedPriceListId;
    },
  },
  data() {
    return {
      /**
       * @description Выбранные категории
       * @type {Array}
       */
      selectedCategories: [],
      /**
       * @description Название выбранного прайс-листа.
       * @type {String}
       */
      selectedPriceListName: '',
      /**
       * @description Идентификатор выбранного прайс-листа.
       * @type {String}
       */
      selectedPriceListId: null,
      /**
       * @description Ожидание загрузки подходящих услуг.
       * @type {boolean}
       */
      isAwaitLoadingMatchedServices: false,
      /**
       * @description Список подходящих услуг.
       * @type {Object[]}
       */
      matchedServiceList: [],
      /**
       * @description Поисковой запрос.
       * @type {String}
       */
      searchQuery: '',
      /**
       * @description Нарушение ограничений при поиске.
       * @type {Object}
       */
      searchViolations: {},
      /**
       * @description Услуги сгруппированные по категориям.
       * @type {Object[]}
       */
      serviceGroupedByCategory: [],
      /**
       * @description Услуги сгруппированные по прайс-листам.
       * @type {Object[]}
       */
      serviceGroupedByPriceList: [],
      /**
       * @description Показывать модальное окно для выбора услуг из прайса.
       * @type {boolean}
       */
      shownAddingServicesFromPriceModal: false,
      /**
       * @description Показывать модальное окно для выбора прайс-листа.
       * @type {boolean}
       */
      shownPriceListsSelectModal: false,
    };
  },
  methods: {
    /**
     * @description Обработать событие клика на выбор услуги.
     * @returns {void}
     */
    onClickServiceSelect() {
      const isOnlyOnePriceList = this.serviceGroupedByPriceList.length === 1;
      if (isOnlyOnePriceList) {
        const firstPriceList = this.serviceGroupedByPriceList[0];
        this.onSelectedPriceList(firstPriceList);
      } else {
        this.shownPriceListsSelectModal = true;
      }
    },
    /**
     * @description Обработать отмену выбора услуг.
     * @returns {void}
     */
    onCancelAddingPriceServices() {
      this.selectedStage = null;
      this.shownAddingServicesFromPriceModal = false;
    },
    /**
     * @description Обработать события выбора прайс-листа.
     * @param {PriceList} priceList
     * @return {void}
     */
    onSelectedPriceList(priceList) {
      this.insertPriceList(priceList);
      this.shownPriceListsSelectModal = false;
      this.shownAddingServicesFromPriceModal = true;
    },
    /**
     * @description Вставить прайс-лист.
     * @param {PriceList} priceList
     * @returns {void}
     */
    insertPriceList(priceList) {
      this.selectedPriceListName = priceList.name;
      this.selectedPriceListId = priceList.id;
      this.selectedCategories = priceList.categoryList;
    },
    /**
     * Обработать событие нажатия на кнопку "Назад".
     * @returns {void}
     */
    onPreviousButton() {
      this.selectedPriceListName = '';
      this.selectedPriceListId = null;
      this.selectedCategories = [];
      this.shownPriceListsSelectModal = true;
      this.shownAddingServicesFromPriceModal = false;
    },
    /**
     * @description Получить подходящие услуги.
     *
     * @param {string} match              Совпадение.
     */
    fetchMatchedServices(match) {
      if (!match) {
        this.matchedServiceList = [];
        return;
      }
      const onFail = (error) => {
        this.searchViolations = error.allCauses();
      };
      const onSuccess = (list) => {
        this.searchViolations = {};
        this.matchedServiceList = list.map((service) => ({
          categoryId: service.categoryId,
          categoryName: service.categoryName,
          priceName: service.priceName,
          cost: service.price,
          duration: service.duration,
          id: service.value,
          name: service.title,
          units: service.units,
        }));
      };
      this.isAwaitLoadingMatchedServices = true;
      this.$serviceGateway
        .allForView(match, this.selectedPriceListId, this.byDefaultServicePriceList)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => {
          this.isAwaitLoadingMatchedServices = false;
        });
    },
  },
  watch: {
    searchQuery: {
      handler: debounce(function _(value) {
        this.fetchMatchedServices(value);
      }, 300),
    },
  },
};
